import { forwardRef } from 'react';
import { useControlledProgressSnackbar } from '../../hooks/use-controlled-progress-snackbar';
import { ProgressSnackbarContent } from './progress-snackbar-content';
import type { ProgressSnackbarProps as Props } from './types';

/**
 * Progress snackbar for controlled progress (e.g., download progress).
 * Reads progress from Zustand store and displays it dynamically.
 */
export const ControlledProgressSnackbar = forwardRef<HTMLDivElement, Props>(
  (props, ref) => {
    const { id, title, icon, message, ...other } = props;

    const { progress: progressValue, formatMessageWithProgress } =
      useControlledProgressSnackbar(id);

    // Format message with progress percentage if message is a string
    const dynamicMessage =
      typeof message === 'string'
        ? formatMessageWithProgress(message)
        : message;

    return (
      <ProgressSnackbarContent
        ref={ref}
        id={id}
        title={title}
        icon={icon}
        message={dynamicMessage}
        progressValue={progressValue}
        className="ProgressSnackbar"
        {...other}
      />
    );
  }
);

ControlledProgressSnackbar.displayName = 'ControlledProgressSnackbar';
